var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.supportedLanguages),function(lang){return _c('router-link',{key:lang,attrs:{"to":_vm.$i18nRoute({ params: { lang: lang }})},nativeOn:{"click":function($event){return _vm.changeLanguage($event)}}},[_vm._v(_vm._s(lang))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }